import { render, staticRenderFns } from "./DBConnections.vue?vue&type=template&id=79fed5c8&"
import script from "./DBConnections.vue?vue&type=script&lang=js&"
export * from "./DBConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports